module.exports = __webpack_public_path__ + "static/media/130-sicily.a1e2d19f.svg";